/**
 * 오늘의 문장을 띄울지 정한다.
 *
 * 세 가지 자료가 서로 다른 때에 도착해서 순서가 중요하다.
 *   내 책(coversLoaded) · 공개 문장(quotes) · 그 사이 사용자의 행동
 *
 * 예전에는 문장이 도착할 때까지 아무것도 정하지 않았다. 새로 가입한
 * 사람은 내 책이 먼저(0권) 도착하는데, 문장을 기다리는 동안 첫 책을 담으면
 * 그때는 이미 1권이라 '아직 한 권도 없는 사람' 조건을 빠져나갔다.
 * 그래서 온보딩이 끝나자마자 남의 문장이 첫 책 축하 위로 덮였다.
 *
 * 이제 책이 도착한 순간 정한다 — 그때 0권이면 문장은 오늘 띄우지 않는다.
 *
 * @returns "wait"  아직 정할 수 없다 (자료가 덜 왔다)
 *          "skip"  오늘은 띄우지 않는다. 다시 묻지 않는다
 *          "show"  띄운다
 */
export default function decideDailyQuote({ coversLoaded, bookCount, quoteCount, blocked = false }) {
  if (blocked) return "wait";        // 기념·새 기능 안내가 떠 있으면 양보한다
  if (!coversLoaded) return "wait";  // myBooks 는 처음엔 누구나 [] 라, 이걸 안 기다리면 모두가 첫 사용자로 잡힌다
  if (bookCount === 0) return "skip";
  if (!quoteCount) return "wait";
  return "show";
}
